// Copyright (c) 2017 Deere & Company

import * as fetchService from '../../../shared/services/fetch';
import {handleError} from '../../../shared/services/error-handlers';

const basePath = '/api';

export const getLeadAccounts = async racfId => {

    const endPoint = `${basePath}/users/${racfId}/audit-dealer-hierarchy`;

    try {

        const response = await fetchService.fetch(endPoint);

        const leadAccountArray = await response.json();

        return leadAccountArray;

    } catch (response) {

        return handleError(response);

    }

};



// WEBPACK FOOTER //
// ./src/user/shared/repositories/lead-accounts.js